import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppNotification } from '../../models/notification.interface';
import {
  NotificationGroup,
  formatNotificationDate,
  groupNotificationsByDate,
} from '../../utils/group-notifications.util';
import { TimeAgoPipe } from '../../pipes/time-ago.pipe';

@Component({
  selector: 'app-notifications-modal',
  standalone: true,
  imports: [CommonModule, TimeAgoPipe],
  templateUrl: './notifications-modal.component.html',
  styleUrls: ['./notifications-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsModalComponent implements OnChanges {
  @Input() isOpen = false;
  @Input() notifications: AppNotification[] | null = [];

  @Output() closeModal = new EventEmitter<void>();
  @Output() notificationClick = new EventEmitter<AppNotification>();

  groups: NotificationGroup[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['notifications'] || changes['isOpen']) {
      this.groups = groupNotificationsByDate(this.notifications ?? []);
    }
  }

  trackByLabel(_: number, group: NotificationGroup): string {
    return group.label;
  }

  trackById(_: number, notification: AppNotification): number {
    return notification.id;
  }

  shouldUseRelativeDate(notification: AppNotification): boolean {
    return formatNotificationDate(notification.createAt) === null;
  }

  formatDate(notification: AppNotification): string {
    return formatNotificationDate(notification.createAt) ?? '';
  }

  onClose(): void {
    this.closeModal.emit();
  }

  onNotificationClick(notification: AppNotification): void {
    this.notificationClick.emit(notification);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.isOpen) {
      this.onClose();
    }
  }
}
